import { toTimeStamp, get } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
export function toItem(data) {
  const isHighDpiAvailable = Boolean(get(data, 'images.hidpi'));
  return {
    id: data.id,
    name: data.title,
    kind: ItemKind.File,
    source: 'dribbble',
    mediaType: MediaType.Picture,
    fileUrl: isHighDpiAvailable ? get(data, 'images.hidpi') : get(data, 'images.normal'),
    previewUrl: get(data, 'images.normal'),
    thumbnailUrl: get(data, 'images.teaser'),
    createdAt: toTimeStamp(data.created_at),
    tags: data.tags,
    width: isHighDpiAvailable ? data.width * 2 : data.width,
    height: isHighDpiAvailable ? data.height * 2 : data.height
  };
}